import api from '@/services/api';
import _ from 'lodash';

export default {

  getTransactionsByPatient(patient) {
    const url = `/virtual-currency/transactions/${patient}`;

    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  countInvoiceRedemptionVcTransactions(invoice) {
    const url = `/virtual-currency/count/redemption-transactions/${invoice}`;

    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  countInvoiceVcTransactions(invoice) {
    const url = `/virtual-currency/count/transactions/${invoice}`;

    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  getBreakdownsByPatient(patient, params) {
    const withData = (params && 'withData' in params) ? params.withData : true;
    const url = `/virtual-currency/breakdowns/${patient}?withData=${withData}`;

    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  requestRedemptions({ patient, invoice, requested , useFreeFirst }) {
    const url = '/virtual-currency/redemption-request';

    return new Promise((resolve, reject) => {
      api.post(url, { patient, invoice, requested , useFreeFirst }).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            // TODO: Chan : Make this cooler
            // get at least one from array of errors
            const errors = _.mapObject(response.body.error.errors, val => val.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  requestUnredeem({ patient, invoice }) {
    const url = '/virtual-currency/unredeem-request';

    return new Promise((resolve, reject) => {
      api.post(url, { patient, invoice }).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            // TODO: Chan : Make this cooler
            // get at least one from array of errors
            const errors = _.mapObject(response.body.error.errors, val => val.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  fetchVCByPatientId({ patientId }) {
    const url = `/virtual-currency/${patientId}`;

    return new Promise((resolve, reject) => {
      api.get(url).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
      );
    });
  },

  transferVirtualCurrency(params) {
    const url = `/virtual-currency/transfer`;
    // console.log('URL ---', url);
    return new Promise((resolve, reject) => {
      api.post(url, params.payload).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            reject(
              new Error(`Error: ${response.data.message}`),
              { data: null, success: false },
            );
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  updateExpiry(id, expiry) {
    const url = `/virtual-currency/${id}`;

    return new Promise((resolve, reject) => {
      api.patch(url, { expiry }).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            // TODO: Chan : Make this cooler
            // get at least one from array of errors
            const errors = _.mapObject(response.body.error.errors, val => val.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  adjustmentUp({ patient, freeAdded, purchaseAdded }) {
    const url = '/virtual-currency/adjustment-up';

    return new Promise((resolve, reject) => {
      api.post(url, { patient, freeAdded, purchaseAdded }).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            // TODO: Chan : Make this cooler
            // get at least one from array of errors
            const errors = _.mapObject(response.body.error.errors, val => val.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  adjustmentDown(id, { patient, freeDeducted, purchaseDeducted }) {
    const url = `/virtual-currency/adjustment-down/${id}`;

    return new Promise((resolve, reject) => {
      api.post(url, { patient, freeDeducted, purchaseDeducted }).then(
        (response) => {
          if (response.ok) {
            const data = response.body;
            resolve({ data, message: '', success: true });
          } else {
            // TODO: Chan : Make this cooler
            // get at least one from array of errors
            const errors = _.mapObject(response.body.error.errors, val => val.message || '');
            reject(new Error(JSON.stringify(errors)));
          }
        },
        (response) => {
          reject(
            new Error(`Request Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        },
      );
    });
  },

  transactionSign({ id, imageBlob }) {
    const url = `/virtual-currency/transactions/${id}/sign`;

    return api.multiPartPatch(url, { signature: imageBlob });
  },
};
